import React, { useEffect, useState } from 'react';
import logo from '../Assest/Om-01.png';

const FreeMasterclass = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds

  useEffect(() => {
    const checkWidth = () => setIsMobile(window.innerWidth <= 768);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  return (
    <div
      style={{
        margin: 0,
        fontFamily: 'Outfit, sans-serif',
        background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)',
        color: 'white',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={logo}
          alt="Billionaire Aniket"
          style={{
            width: '400px',
            height: '200px',
            borderRadius: '20px',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Title */}
      <div style={{ textAlign: 'center', padding: isMobile ? '5px 15px' : '5px 20px' }}>
        <h1 style={{ color: 'white', fontSize: isMobile ? '16px' : '30px', lineHeight: 1.4 }}>
          Trusted Debt Collection Partner Across Maharashtra
        </h1>
      </div>

      {/* Main Section */}
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          padding: '10px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {/* Video */}
        <div style={{ flex: 1, minWidth: '300px', display: 'flex', justifyContent: 'center' }}>
          <div
            style={{
              position: 'relative',
              paddingBottom: '56.25%',
              width: '100%',
              maxWidth: '500px',
              height: 0,
              overflow: 'hidden',
              borderRadius: '16px',
              border: '2px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/LJWEyLvCgNE?si=pV6r8O0GlKFe-aD0"
              title="Masterclass Preview"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Info Boxes */}
        <div style={{ flex: 1, minWidth: '300px', padding: '10px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
              gap: '15px',
            }}
          >
            {[
              {
                icon: '📅',
                label: 'Date',
                value: (
                  <>
                    12th & 13th July
                    <br />
                    <span style={{ color: '#F8C74B' }}>Sat & Sun</span>
                  </>
                ),
              },
              { icon: '⏰', label: 'Time', value: '7:30 to 9:30 PM' },
              { icon: '🎥', label: 'Venue', value: 'Zoom' },
              { icon: '🌐', label: 'Language', value: 'Marathi' },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  padding: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                }}
              >
                <span style={{ fontSize: '24px', color: '#fbbc04', marginRight: '10px' }}>
                  {item.icon}
                </span>
                <div>
                  <div style={{ fontSize: '14px' }}>{item.label}</div>
                  <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer Line */}
      <div
        style={{
          textAlign: 'center',
          padding: '30px 20px 50px',
          fontSize: isMobile ? '16px' : '20px',
          maxWidth: '800px',
          margin: '0 auto',
          lineHeight: 1.6,
          color: '#ccc',
        }}
      >
        We foster long-term partnerships by delivering consistent, reliable, and results-driven
        services, earning the continued trust of our clients.
      </div>
    </div>
  );
};

export default FreeMasterclass;
